import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { PageHero, Section } from "@/components/ui-helpers";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {}); }, []);
  const [featured, ...rest] = posts;
  return (
    <>
      <SEO title="The Ascendia Guide" description="Guides on post-construction cleaning, move-in preparation, property detailing and surface care." />
      <PageHero kicker="The Ascendia Guide" title="Learn how properties are properly prepared" subtitle="Practical, honest guides on cleaning, detailing and getting a property move-in ready." />
      <Section>
        {featured && (
          <Reveal>
            <Link to={`/blog/${featured.slug}`} className="ascendia-card group grid md:grid-cols-2 overflow-hidden mb-10">
              <div className="relative h-64 md:h-auto overflow-hidden"><img src={featured.cover} alt={featured.title} className="h-full w-full object-cover opacity-80 group-hover:scale-105 transition-transform duration-500" /></div>
              <div className="p-8 flex flex-col justify-center">
                <span className="text-[11px] uppercase tracking-[0.16em] text-gold-soft">{featured.category}</span>
                <h2 className="mt-3 font-display text-2xl font-semibold text-white">{featured.title}</h2>
                <p className="mt-3 text-secondary">{featured.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm text-gold-soft">Read guide <ArrowRight className="h-4 w-4" /></span>
              </div>
            </Link>
          </Reveal>
        )}
        <div className="grid md:grid-cols-3 gap-6">
          {rest.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.06}>
              <Link to={`/blog/${p.slug}`} className="ascendia-card group overflow-hidden h-full flex flex-col">
                <div className="relative h-44 overflow-hidden"><img src={p.cover} alt={p.title} className="h-full w-full object-cover opacity-80 group-hover:scale-105 transition-transform duration-500" /></div>
                <div className="p-6 flex flex-col flex-1">
                  <span className="text-[11px] uppercase tracking-[0.16em] text-gold-soft">{p.category}</span>
                  <h3 className="mt-2 font-display text-lg font-semibold text-white">{p.title}</h3>
                  <p className="mt-2 text-sm text-secondary flex-1">{p.excerpt}</p>
                  <span className="mt-3 text-xs text-muted-c flex items-center gap-1"><Clock className="h-3 w-3" /> {p.read_time}</span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </Section>
    </>
  );
}
